export enum LeadProgression {
  LEAD = 'LEAD',
  PROPOSAL = 'PROPOSAL',
  OFFER_ACCEPTED = 'OFFER_ACCEPTED',
  SUBMISSION = 'SUBMISSION',
  POLICY = 'POLICY',
}

export const getLeadProgressionLabel = (value: LeadProgression) => {
  switch (value) {
    case LeadProgression.LEAD:
      return $localize`Leads`;
    case LeadProgression.PROPOSAL:
      return $localize`Propositions`;
    case LeadProgression.OFFER_ACCEPTED:
      return $localize`Contrats à soumettre`;
    case LeadProgression.SUBMISSION:
      return $localize`Contrats soumis`;
    case LeadProgression.POLICY:
      return $localize`Polices`;
  }
};
